<template>
  <layout-component>
      <div class="banner banner-homepage noise">
        <div class="container">
          <div class="text-wrapper">
            <h1 class="left-bullet"><anim-text :text="$t('w.home.title-banner')" /></h1>
            <div class="baseline">
              <span class="left-bullet"><anim-text :text="$t('w.home.baseline-banner')" /></span>
            </div>
          </div>
        </div>
      </div>

      <div class="main-homepage">
          <div class="container">
              <div class="row">
                      <div class="col-md-5">
                          <div class="wide-left d-none d-md-block">
                            <div class="noise">
                              <b-img src="/storage/img/pic/pic-homepage-01.webp" alt="Guitarist playing" />
                            </div>
                          </div>
                      </div>

                      <div class="offset-md-1 col-md-6 pt-md-5">
                          <p class="h4-style bottom-cut" v-html="$t('w.home.title-01')"></p>

                          <p class="pr-lg-5">{{ 'w.home.text-01' | t }}</p>
                      </div>
                  </div>

                  <div class="row mb-3 mb-lg-5 d-flex justify-content-end video-homepage">
                    <div class="col-md-7">
                      <div class="video-wrapper">
                        <iframe src="https://player.vimeo.com/video/1009867688" id="video" width="640" height="360" title="Sonotron teaser" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                      </div>
                      <!-- <div class="noise">
                        <b-img src="/storage/img/pic/pic-homepage-03.webp" />
                      </div> -->
                    </div>
                  </div>

              <div class="mb-3 mb-lg-5">
                  <p class="h2-style">
                      <span><anim-text :text="$t('w.home.big-cta-01-text')" /></span>
                      <router-link class='btn-link btn-link-big left-bullet' to='/events' exact><anim-text :text="$t('w.home.big-cta-00')" /></router-link>
                      <span><anim-text :text="$t('w.home.big-cta-00-text')" /></span>
                      <router-link class='btn-link btn-link-big left-bullet' to='/book' exact><anim-text :text="$t('w.home.big-cta-01')" /></router-link>
                  </p>
              </div>
          </div>

          <div class="container-full container-white">
              <div class="container pb-4 pb-lg-5">
                  <div class="row d-flex align-items-center">
                      <div class="col-md-5">
                        <div class="noise neg-img">
                          <b-img src="/storage/img/pic/pic-homepage-02.webp" alt="Woman singing" />
                        </div>
                      </div>

                      <div class="col-md-6 offset-md-1 offset-lg-1 col-lg-4 mt-15">
                          <p class="h4-style bottom-cut mt-2 mt-md-2 mt-lg-4" v-html="$t('w.home.title-02')"></p>

                          <p v-html="$t('w.home.text-02')"></p>

                          <img class="mt-10" src="/storage/img/logo/logo-sonotronx1535.svg" alt="Sonotron 1535 logo" />
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-6 col-lg-4">
                          <p class="h4-style bottom-cut mt-3 mt-md-4 mt-lg-5" v-html="$t('w.home.title-03')"></p>
                          <p>{{'w.home.text-03'|t}}</p>
                      </div>

                      <div class="col-md-6 col-lg-4 offset-lg-2">
                          <p class="h4-style bottom-cut mt-2 mt-md-4 mt-lg-5" v-html="$t('w.home.title-04')"></p>
                          <p v-html="$t('w.home.text-04')"></p>
                      </div>
                  </div>
              </div>

              <div class="blog pt-4 pb-4 pb-md-5 mt-lg-5 pt-lg-3" style="overflow-x: hidden;">
                  <div class="container">
                    <div class="row">
                      <div class="col-lg-4 col-xl-3 blog-swiper-title">
                        <h2 class="dark left-bullet"><anim-text :text="$t('w.home.title-05')" /></h2>
                        <div class="d-none d-md-block mb-3">
                          <router-link class="btn w-75" to="/events" active-class="active"><span>{{'w.home.cta-05'|t}}</span></router-link>
                          <router-link class="btn w-75" to="/blog" active-class="active"><span>{{'w.home.cta-06'|t}}</span></router-link>
                        </div>
                      </div>

                      <div class="offset-lg-1 col-lg-7 offset-xl-1 col-xl-8 blog-swiper">
                        <swiper v-if="blogposts" :options="swiperOption" >
                          <swiper-slide v-for="(post) in blogposts" :key="post.id">
                            <div class="card-blog-homepage">

                              <router-link :to="'/blog/post/'+post.slug" v-if="post.blog_category_id">
                                <div class="img-wrapper">
                                  <div class="noise">
                                    <img class="img-fluid" v-if="post.image"  :src="'/storage/'+post.image" alt="Blog article cover" />
                                  </div>
                                </div>
                                <div class="text-wrapper">
                                  <div class="date bottom-cut">{{ post.date | formatDateBlog }}</div>
                                  <h3 class="bottom-cut">{{ $i18n.locale == 'fr' ? post.title : post.title_en }}</h3>
                                   <p>{{'w.home.label-blog'|t}}</p>
                                </div>
                              </router-link>

                              <router-link :to="'/events/'+post.slug" v-else>
                                <div class="img-wrapper">
                                  <div class="noise">
                                    <img class="img-fluid" v-if="post.cover"  :src="'/storage/'+post.cover" alt="Event cover" />
                                  </div>
                                </div>
                                <div class="text-wrapper">
                                  <div class="date bottom-cut">{{ post.start_date | formatDateBlog }} > {{ post.end_date | formatDateBlog }}</div>
                                  <h3 class="bottom-cut">{{ $i18n.locale == 'fr' ? post.name : post.name_en }}</h3>
                                  <p>{{'w.home.label-event'|t}}</p>
                                </div>
                              </router-link>
                            </div>
                          </swiper-slide>
                        </swiper>
                        <div class="swiper-navigation">
                          <div class="swiper-button-prev swiper-button"></div>
                          <div class="swiper-button-next swiper-button"></div>
                        </div>
                        <div class="d-flex justify-content-center d-md-none">
                          <router-link class="btn mr-1" to="/events" active-class="active"><span>{{'w.home.cta-05'|t}}</span></router-link>
                          <router-link class="btn" to="/blog" active-class="active"><span>{{'w.home.cta-06'|t}}</span></router-link>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>


          <div class="banner-prefooter banner-prefooter-homepage noise">
              <div class="container">
                  <p class="h2-style">
                      <span><anim-text :text="$t('w.home.big-cta-02-text')" /></span>
                      <router-link class='btn-link btn-link-big left-bullet' to='/book' exact><anim-text :text="$t('w.home.big-cta-02')" /></router-link>
                  </p>
              </div>
          </div>
      </div>

  </layout-component>
</template>

<script>
  export default {
    data() {
      return {
        blogposts:null,
        swiperOption: {
          slidesPerView: 'auto',
          loop: true,
          spaceBetween: 30,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      }
    },
    methods: {
      setData(data) {
        this.blogposts = data;
      },
    },
    beforeRouteEnter(to, from, next) {
      Vue.axios.get('/blog/limit/0/5').then( ({data}) => {
        next(vm => vm.setData(data))
      });
    },
    mounted() {
      $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
      if ( $( '.banner-prefooter .title-anim-wrapper' ).is( ':in-viewport' ) ) {
        $('.banner-prefooter').addClass('in-viewport');
      };
      $('.noise').each(function() {
        if ($(this).is( ':in-viewport' ) ) {
          $(this).addClass('in-viewport');
        } else {
          $(this).removeClass('in-viewport');
        }
      });
    }
  }
</script>
